import type { SimpleGit } from 'simple-git';
import { cliSimpleGit } from '../../cli-simple-git.js';
import { resolveBaseShaForUnpushedCommits } from './resolve-base-sha-for-unpushed-commits.js';
import { revParseSafe } from './rev-parse-safe.js';

/**
 * Count commits reachable from HEAD but not from the chosen base (upstream tip, else remote default branch).
 */
export async function commitsAheadOfRemoteTracking(repoDir: string): Promise<number> {
  const g = cliSimpleGit(repoDir);
  const headSha = await revParseSafe(g, 'HEAD');
  if (!headSha) return 0;
  const baseSha = await resolveBaseShaForUnpushedCommits(g, repoDir);
  if (!baseSha || baseSha === headSha) return 0;
  try {
    const out = await g.raw(['rev-list', '--count', `${baseSha}..${headSha}`]);
    const n = parseInt(String(out).trim(), 10);
    return Number.isNaN(n) ? 0 : n;
  } catch {
    return 0;
  }
}
